import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ChannelRatesInventoryLog
 *
 * @property {number} id
 */
export class ChannelRatesInventoryLog extends Model {


}

AccessorsMutatorsDecorator(
    'date',
    'rooms',
    'inventory',
)(ChannelRatesInventoryLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/channel-rates-inventory-log.model.js